import React from 'react';
import * as Style from './CompanyLabel.styles';
import { ICompanyLabelProps } from './CompanyLabel.types';

export const CompanyLabel: React.FC<ICompanyLabelProps> = ({ children, testID }) => (
  <Style.CompanyLabel data-testid={testID}>{children}</Style.CompanyLabel>
);
